import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { FRONTEND_URL } from "../config/axios";
import Applymodels from "../pages/Applymodels";
import { useNavigate } from "react-router-dom";
import { SearchBig } from "../components/AllSvg";
import { Notification } from "../components/AllSvg";
import { routingData } from "../routes/routing";
import { Modal } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";

const Dashboardnavbar = ({ name, url, showurl }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  const data = [
    // ... your existing data array
  ];

  const fetchData = async () => {
    const allNotifications = data;
    setNotifications(allNotifications.filter((n) => n.is_read === "Unread"));
    setUnreadCount(
      allNotifications.filter((n) => n.is_read === "Unread").length,
    );
    handleShowNotifications();
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleShowNotifications = () => {
    notifications.forEach((notification) => {
      if (notification.is_read === "Unread") {
        toast(notification.message, {
          onClose: () => markAsRead(notification.emp_code),
        });
      }
    });
  };

  const markAsRead = (id) => {
    console.log("Marking as read for ID:", id);
    const updatedNotifications = notifications.map((notification) =>
      notification.id === id
        ? { ...notification, is_read: "Read" }
        : notification,
    );
    setNotifications(
      updatedNotifications.filter((n) => n.is_read === "Unread"),
    );
    setUnreadCount(
      updatedNotifications.filter((n) => n.is_read === "Unread").length,
    );
  };

  const empname = sessionStorage.getItem("name");
  const empCode = sessionStorage.getItem("sitemanagement_emp_code");
  const role = sessionStorage.getItem("sitemanagement_role");
  const EMAIL = sessionStorage.getItem("email");

  const clearAllNotifications = () => {
    const updatedNotifications = notifications.map((notification) => ({
      ...notification,
      is_read: "Read",
    }));
    setNotifications(
      updatedNotifications.filter((n) => n.is_read === "Unread"),
    );
    setUnreadCount(0);
  };

  const [isOpen, setIsOpen] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  const navigate = useNavigate();

  const [searchInput, setSearchInput] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [availableRoutes, setAvailableRoutes] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  // Get user info from sessionStorage
  const userName =
    sessionStorage.getItem("userName") ||
    sessionStorage.getItem("username") ||
    "User";
  const userRole =
    sessionStorage.getItem("role") ||
    sessionStorage.getItem("sitemanagement_role") ||
    "Role";
  const userEmail = sessionStorage.getItem("userEmail") || "";

  // Get first letter for avatar

  const flattenRoutes = (routes) => {
    let flatRoutes = [];

    const flatten = (routeList, parentPath = "") => {
      routeList.forEach((route) => {
        const fullPath = parentPath
          ? `${parentPath}/${route.path}`
          : route.path;
        if (!fullPath.includes("/:")) {
          const cleanedPath = fullPath.replace(/^admin\//, "");
          flatRoutes.push({ ...route, path: cleanedPath });
        }
        if (route.routes && Array.isArray(route.routes)) {
          flatten(route.routes, fullPath);
        }
      });
    };

    flatten(routes);
    return flatRoutes;
  };

  const handleSearchChange = (e) => {
    const input = e.target.value.trim();
    setSearchInput(input);

    if (input) {
      const filtered = availableRoutes.filter((route) =>
        (route.label || route.path).toLowerCase().includes(input.toLowerCase()),
      );
      setSuggestions(filtered);
      setShowSuggestions(true);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  };

  const currentUrl = window.location.href;
  const urlParts = currentUrl.split("/");

  const handleSuggestionClick = (path) => {
    setSearchInput("");
    setSuggestions([]);
    setShowSuggestions(false);
    const staticPath = path.split("/:")[0];
    navigate(`/${urlParts[3]}/${staticPath}`);
  };

  const handleClickOutside = (e) => {
    if (!e.target.closest(".navbar-search")) {
      setShowSuggestions(false);
    }
    // Close profile menu when clicking outside
    if (!e.target.closest(".profile-dropdown")) {
      setShowProfileMenu(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleShowMessenger = () => {
    navigate("/certificaionadminaccess/messenger");
  };

  // Handle logout
  const handleLogout = () => {
    toast.info("Logging Out...");
    sessionStorage.clear();
    setTimeout(() => {
      window.location = FRONTEND_URL;
    }, 500);
  };

  // Toggle profile menu
  const toggleProfileMenu = () => {
    setShowProfileMenu(!showProfileMenu);
  };

  console.log(showurl, "bd show");

  const getFirstLetter = () => {
    if (empname) {
      return empname.charAt(0).toUpperCase();
    } else {
      return "U";
    }
  };
  useEffect(() => {
    const userRole = sessionStorage.getItem("role") || "";
    const roleData = routingData.find((route) => route.role === userRole);

    if (roleData) {
      if (roleData.nestedRoutes && Array.isArray(roleData.nestedRoutes)) {
        const flattenedRoutes = flattenRoutes(roleData.nestedRoutes);
        setAvailableRoutes(flattenedRoutes);
      } else {
        setAvailableRoutes([]);
      }
    } else {
      setAvailableRoutes([]);
    }
  }, []);
  return (
    <div className="navbar-section-main" style={{ background: "transparent" }}>
      <div className="navbar-heading font-weight700">{name}</div>

      <div className="navbar-subsection">
        {/* Profile Dropdown */}
        <div className="profile-dropdown">
          <div className="flex-row" style={{ gap: "5px" }}>
            <div className="">
              <button
                className="profile-button"
                onClick={toggleProfileMenu}
                title={userName}
              >
                <div className="profile-avatar">{getFirstLetter()}</div>
              </button>
            </div>
            <div className="profile-name">
              {empname ? empname : empCode ? empCode : "User"}
            </div>
          </div>

          {showProfileMenu && (
            <div
              className="profile-menu "
              style={{ top: "63px", right: "18px" }}
            >
              <div className="profile-info">
                <div className="profile-name">
                  {empname ? empname : empCode ? empCode : "User"}
                </div>
                <div className="profile-role">{role ? role : "User"}</div>
                {EMAIL && <div className="profile-email">{EMAIL}</div>}
              </div>
              <div className="profile-divider"></div>
              <button
                className="profile-logout-btn"
                style={{ justifyContent: "center" }}
                onClick={handleLogout}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                  <polyline points="16 17 21 12 16 7" />
                  <line x1="21" y1="12" x2="9" y2="12" />
                </svg>
                Logout
              </button>
            </div>
          )}
        </div>

        {/* <div className="navbar-logo-mobile">
            <button
              title="logout"
              className="navbar-svg"
              onClick={handleLogout}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-box-arrow-right" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z" fill="#A3AED0" />
                <path fillRule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z" fill="#A3AED0" />
              </svg>
            </button>
          </div> */}
      </div>
    </div>
  );
};

export default Dashboardnavbar;
